function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M173.195 13.011C173.195 6.466 167.691 1 160.898 1h-12.785c-.522 0-1.045.244-1.567.522l-25.884 24.302C112.058 34.179 100.04 38.6 86.976 38.6c-13.621 0-25.884-4.944-34.767-13.822 0 0-18.811-17.79-19.09-18.034C29.461 3.333 24.514 1 18.766 1H3.334A2.333 2.333 0 001 3.333v67.925c0 6.79 5.47 12.012 12.019 12.012H21.1a2.349 2.349 0 002.368-2.368V56.88c0-6.51 5.226-11.733 11.218-11.733 11.774 0 19.856 9.923 27.45 16.712 9.128 8.077 16.2 15.91 24.839 15.91 8.883 0 15.92-7.833 25.082-15.91 7.56-6.789 15.676-16.712 27.172-16.712 6.27 0 11.496 5.223 11.496 11.49v14.622c0 6.79 5.47 12.012 12.019 12.012h8.082a2.349 2.349 0 002.368-2.368v-67.89z",
  fill: "#503291"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177.49604 85.558008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4e45fab9.svg";
export { ForwardRef as ReactComponent };